import { CourseHistory } from '../parts/academicHistory/academicHistorytabs/Curriculum/types/history';
import { CurriculumProgressBase } from '../../CurriculumProgressStudent/types/progress';
import request from '../../../api/request';
import { ProgressCurrentPeriodResponse } from '../parts/academicHistory/academicHistorytabs/ProgressInCurrentPeriod/types';
import { TitulationData } from '../parts/academicHistory/academicHistorytabs/Titulation/types';

const ACADEMIC_HISTORY = {
  GET_POSTULANT_ACADEMIC_HISTORY: (studentId: string | number) =>
    `maintainers-portal/student-management/academic-history/${studentId}`,
  GET_ACADEMIC_HISTORY_PROGRESS: (studyPlanEnrollmentId: string | number) =>
    `maintainers-portal/student-management/academic-history/students/${studyPlanEnrollmentId}`,
  GET_ACADEMIC_HISTORY_GRADES: (studyPlanEnrollmentId: string | number) =>
    `maintainers-portal/student-management/academic-history/grades-history/${studyPlanEnrollmentId}`,
  GET_TITULATION_DATA: (studyPlanEnrollmentId: string | number) =>
    `maintainers-portal/student-management/academic-history/titulation-data/${studyPlanEnrollmentId}`,
  GET_CURRICULUM_PROGRESS: (studyPlanEnrollmentId: string | number) =>
    `maintainers-portal/student-management/academic-history/curriculum/${studyPlanEnrollmentId}`,
};

export const getAcademicHistoryGrades = (id: number | string) => {
  return request<CourseHistory>(
    ACADEMIC_HISTORY.GET_ACADEMIC_HISTORY_GRADES(id),
  );
};

export function getCurriculumProgress(studyPlanEnrollmentId: number | string) {
  const url = ACADEMIC_HISTORY.GET_CURRICULUM_PROGRESS(studyPlanEnrollmentId);
  return request<CurriculumProgressBase>(url);
}

export const getPostulantAcademicHistory = (id: number | string) => {
  return request(ACADEMIC_HISTORY.GET_POSTULANT_ACADEMIC_HISTORY(id));
};

export const getProgressInCurrentPeriod = (id: number | string) => {
  return request<ProgressCurrentPeriodResponse>(
    ACADEMIC_HISTORY.GET_ACADEMIC_HISTORY_PROGRESS(id),
  );
};

export const getTitulationData = (studyPlanEnrollmentId: number | string) => {
  return request<TitulationData>(
    ACADEMIC_HISTORY.GET_TITULATION_DATA(studyPlanEnrollmentId),
  );
};
